import './cardChangeNewPaymentMethodView.scss';

import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { i18n } from 'core/i18n';

import * as cardChangePaymentMethodActions from 'actions/cardChangeNewPaymentMethod';
import * as hirePaymentMethodActions from 'actions/hirePaymentMethod';
import revolvingActions from 'actions/cardRevolvingDocuments';
import * as hireNewCreditCardActions from 'actions/hireNewCreditCard';
import * as hireInformationActions from 'actions/hireInformation';

import { OKCover } from 'commonsComponents/OKCover';
import { OKHeaderSubPage } from 'commonsComponents/OKHeaderSubPage';

import { contactCenterClassName, conditionalClassName } from 'utilities/conditionals/conditionalClassname';
import AccessHelper from 'utilities/accessHelper';
import { PAGE_GENERIC, recordPath } from 'utilities/tagging';
import { cardConstants } from 'utilities/accessHelperConditions/cards';

import CardHeaderDetails from 'components/cards/cardHeaderDetails/cardHeaderDetails';
import CardChangePaymentMethodSuccessStep from 'components/cards/cardChangePaymentMethodSteps/cardChangePaymentMethodSuccessStep/cardChangePaymentMethodSuccessStep';
import CardChangePaymentMethodErrorStep from 'components/cards/cardChangePaymentMethodSteps/cardChangePaymentMethodErrorStep/cardChangePaymentMethodErrorStep';
import CardDetailsSidebar from 'components/cards/cardDetailsSidebar/cardDetailsSidebar';

import { CardChangeNewPaymentMethod } from 'components/cards/cardChangePaymentMethod/cardChangeNewPaymentMethod';
import { LoadingSection } from 'commonsComponents/loadingSection';
import { CARD_INTERVENTION_OWNER } from 'constants/index';
import { CREDIT_CARD_REVOLVING_PROCESS, NOT_ALLOWED_NEW_CREDITCARD_PAYMENT_METHOD_CHANGE_COUNTRIES } from 'constants/flagBasedFeatures';

import { getPlacementIdCard, getServiceCodes } from '../hireNewCreditCardView/hireNewCreditCardViewUtilities';

const CardChangeNewPaymentMethodView = (props) => {
    const { match: { params: { cardId } },
        immCards,
        immCardChangePaymentMethod,
        handleAgreementCheckboxChange,
        immGlobalVariables,
        validateStep,
        setVisibleStep,
        setWillCancel,
        immFlagBasedFeatures,
        postChange,
        history,
        requestPaymentMethodInfo,
        immHireCreditLimit,
        immHirePaymentMethod,
        setTooltipShown,
        handleTypeChange,
        handleValueChange,
        requestAfiInformation,
        setAFIParams,
        setInneParams,
        newSetHireCreditCardType,
        immPdfRevolvingPersistent,
        setDisabledButton,
        documentRead,
        saveDocumentList,
        onAcceptAllDocument,
        checkRadioButtonIneDir,
        clearRequest,
        immHireCardNameSelector,
        immShippingAddressList,
        immProfile,
        onHandleChangeCheckBoxCC,
        processEmail,
        getHireInformation,
        agreeCheckboxCC,
        immPrinter,
        setMethod
    } = props
    const { formatText, getFinalTitle } = i18n;
    const immCard = immCards.get('byId').get(cardId);
    const type = immCard.get('type');
    const subtitleLeft = formatText(`cards-${type}`);
    const subtitleRight = immCard.get('alias').get('current');
    const changePaymentBodyClassName = contactCenterClassName('card-change-payment-method-view__body', 'grid-view__body')
    const changePaymentContainerClassName = contactCenterClassName('card-change-payment-method-view__container', 'container-fluid')
    const success = immCardChangePaymentMethod.get('submitSuccessful')
    const hasError = !!immCardChangePaymentMethod.get('error');
    const showIneAndRevolving = immFlagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
    const changePaymentSidebarClassName = conditionalClassName('hidden-md', 'col-md-4', 'hidden-xs hidden-sm col-lg-4')
    const isLoading = immCards.get('isFetching')
    const interventionType = immCard && immCard.get('interventionType') !== CARD_INTERVENTION_OWNER
    const tin = immPdfRevolvingPersistent.getIn(['paramsInne', 'tin'])
    const tae = immPdfRevolvingPersistent.getIn(['paramsInne', 'tae'])
    const installmenAmount = immPdfRevolvingPersistent.get('firstPaymentAmount')
    const newCreditCardsMethodFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_CREDITCARD_PAYMENT_METHOD_CHANGE_COUNTRIES);
    const method = immCardChangePaymentMethod.getIn(['steps', 0, 'currentPaymentMethod'])
    const currentMethod = immHirePaymentMethod.get('type');
    const documentsPrintedAndSigned = immPrinter.get('documentsPrintedAndSigned')
    const [isCheckboxCheckedStep1, setIsCheckboxCheckedStep1] = useState(false);
    useEffect(() => {
        const immCard = immCards.getIn(['byId', cardId]);
        const tagging = immCard.get('tagging');

        AccessHelper.allowAccess(cardConstants.CARD_CHANGE_PAYMENT_METHOD, { immCard, immFlagBasedFeatures }, history);
        requestPaymentMethodInfo(cardId);
        recordPath('tarjeta/cambio-metodo-pago', PAGE_GENERIC, '', '', tagging);
    }, [])
    useEffect(() => {
        handleTypeChange(method)
    }, [method])

    useEffect(() => {
        return () => {
            clearRequest();
        };
    }, [clearRequest]);
    const mappingBreadcrumb = [
        {
            text: formatText('breadcrumb-cards'),
            url: '/myprofile/cards'
        },
        {
            text: immCard.get('alias').get('current'),
            url: `/myprofile/cards/${cardId}/movements`
        },
        {
            text: formatText('cardChangePaymentMethod-title')
        }
    ];
    const handleFinish = () => {
        postChange(cardId);
    }
    const goToMovementsPage = () => {
        history.push(`/myprofile/cards/${cardId}/movements`)
    }

    return (
        <div>
            <div className="container-fluid">
                <div className="row">
                    <OKCover size="medium" section="cards" customClass="col-xs-12">
                        <OKHeaderSubPage
                            breadcrumbConfig={mappingBreadcrumb}
                            subtitleLeft={subtitleLeft}
                            subtitleRight={subtitleRight}
                            finalTitle={getFinalTitle('cardChangePaymentMethod-title')}>
                            <CardHeaderDetails immCard={immCard} />
                        </OKHeaderSubPage>
                    </OKCover>
                </div>
            </div>
            <div className={changePaymentBodyClassName}>
                <div className={changePaymentContainerClassName}>
                    <div className="row grid-view--content-position-negative">
                        {interventionType ? goToMovementsPage() :
                            isLoading ?
                                <LoadingSection />
                                : success ?
                                    <CardChangePaymentMethodSuccessStep
                                        immCard={immCard}
                                        currentMethod={currentMethod}
                                        immHirePaymentMethod={immHirePaymentMethod}
                                    /> :
                                    hasError ?
                                        <CardChangePaymentMethodErrorStep
                                            immCard={immCard}
                                            immCardChangePaymentMethod={immCardChangePaymentMethod}
                                        />
                                        :
                                        <div>
                                            <div className="col-md-12-cc-8 col-lg-8">

                                                <CardChangeNewPaymentMethod
                                                    handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                                                    immCard={immCard}
                                                    immCardChangePaymentMethod={immCardChangePaymentMethod}
                                                    immGlobalVariables={immGlobalVariables}
                                                    validateStep={validateStep}
                                                    setVisibleStep={setVisibleStep}
                                                    setWillCancel={setWillCancel}
                                                    showIneAndRevolving={showIneAndRevolving}
                                                    postChange={postChange}
                                                    onFinish={handleFinish}
                                                    isDisabledButton={immCardChangePaymentMethod.get('isDisabledButton')}
                                                    immHireCreditLimit={immHireCreditLimit}
                                                    immHirePaymentMethod={immHirePaymentMethod}
                                                    setTooltipShown={setTooltipShown}
                                                    handleTypeChange={handleTypeChange}
                                                    handleValueChange={handleValueChange}
                                                    requestAfiInformation={requestAfiInformation}
                                                    setAFIParams={setAFIParams}
                                                    setInneParams={setInneParams}
                                                    newSetHireCreditCardType={newSetHireCreditCardType}
                                                    immFlagBasedFeatures={immFlagBasedFeatures}
                                                    immPdfRevolvingPersistent={immPdfRevolvingPersistent}
                                                    setDisabledButton={setDisabledButton}
                                                    method={method}
                                                    currentMethod={currentMethod}
                                                    documentRead={documentRead}
                                                    onAcceptAllDocument={onAcceptAllDocument}
                                                    saveDocumentList={saveDocumentList}
                                                    checkRadioButtonIneDir={checkRadioButtonIneDir}
                                                    immHireCardNameSelector={immHireCardNameSelector}
                                                    immShippingAddressList={immShippingAddressList}
                                                    getPlacementIdCard={getPlacementIdCard}
                                                    getServiceCodes={getServiceCodes}
                                                    history={history}
                                                    immProfile={immProfile}
                                                    isCheckboxCheckedStep1={isCheckboxCheckedStep1}
                                                    setIsCheckboxCheckedStep1={setIsCheckboxCheckedStep1}
                                                    agreeCheckboxCC={agreeCheckboxCC}
                                                    onHandleChangeCheckBoxCC={onHandleChangeCheckBoxCC}
                                                    processEmail={processEmail}
                                                    getHireInformation={getHireInformation}
                                                    documentsPrintedAndSigned={documentsPrintedAndSigned}
                                                    setMethod={setMethod}
                                                />

                                            </div>
                                            <div className={changePaymentSidebarClassName}>
                                                <CardDetailsSidebar installmenAmount={installmenAmount} immCard={immCard} newCreditCardsMethodFF={newCreditCardsMethodFF} tin={tin} tae={tae} method={method} currentMethod={currentMethod} currentInstallments={immHirePaymentMethod.get('value')}
                                                />
                                            </div>
                                        </div>}
                    </div>
                </div>
            </div>
        </div>
    );
}

module.exports.constructor = CardChangeNewPaymentMethodView;
module.exports.CardChangeNewPaymentMethodView = connect(
    state => ({
        immCards: state.cards,
        immCardChangePaymentMethod: state.cardChangeNewPaymentMethod,
        immGlobalVariables: state.globalVariables,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immHireCreditLimit: state.hireCreditLimit,
        immHirePaymentMethod: state.hirePaymentMethod,
        immPdfRevolvingPersistent: state.revolvingPersistentData,
        immHireCardNameSelector: state.hireCardNameSelector,
        immShippingAddressList: state.shippingAddress,
        immProfile: state.profile,
        immPrinter: state.printer,


    }),
    {
        handleAgreementCheckboxChange: cardChangePaymentMethodActions.setAgreementCheckbox,
        validateStep: cardChangePaymentMethodActions.newValidateStep,
        setVisibleStep: cardChangePaymentMethodActions.setVisibleStep,
        setWillCancel: cardChangePaymentMethodActions.setWillCancel,
        postChange: cardChangePaymentMethodActions.postChange,
        requestPaymentMethodInfo: cardChangePaymentMethodActions.requestPaymentMethodInfo,
        setMethod: cardChangePaymentMethodActions.setMethod,
        setDisabledButton: cardChangePaymentMethodActions.setDisabledButton,
        setTooltipShown: hirePaymentMethodActions.setTooltipShown,
        handleTypeChange: hirePaymentMethodActions.setType,
        handleValueChange: hirePaymentMethodActions.setValue,
        requestAfiInformation: revolvingActions.requestAfiInformation,
        setAFIParams: revolvingActions.setAFIParams,
        setInneParams: revolvingActions.setInneParams,
        newSetHireCreditCardType: hireNewCreditCardActions.setHireCreditCardLimit,
        documentRead: hireNewCreditCardActions.documentRead,
        onAcceptAllDocument: hireNewCreditCardActions.onAcceptAllDocument,
        saveDocumentList: hireNewCreditCardActions.saveDocumentList,
        checkRadioButtonIneDir: hireNewCreditCardActions.checkRadioButtonIneDir,
        clearRequest: cardChangePaymentMethodActions.clearRequest,
        agreeCheckboxCC: cardChangePaymentMethodActions.agreeCheckboxCC,
        onHandleChangeCheckBoxCC: cardChangePaymentMethodActions.onHandleChangeCheckBoxCC,
        processEmail: cardChangePaymentMethodActions.processEmail,
        getHireInformation: hireInformationActions.getHireInformation,



    }
)(withRouter(CardChangeNewPaymentMethodView));

